import Cookies from "universal-cookie"

import config from "../config"
import getCompleteApiUrl from "../getCompleteApiUrl"
import { AssetReadinessRequirement } from "../../classes/AssetReadinessRequirement"
import {ApiCallFailure} from "../../classes/exception/ApiCallFailure";

export default async function createReadinessRequirementInAssetById(requirement: AssetReadinessRequirement) {
    const cookies = new Cookies()

    if (cookies.get("accessToken") === undefined) {
        const error = new ApiCallFailure()
        error.connectionSuccessful = false
        error.errorType = "NO_ACCESS_TOKEN"

        throw error
    }

    var res: Response
    try {
        res = await fetch(getCompleteApiUrl(config, `/assets/id/${requirement.assetId}/readiness/requirements`), {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${cookies.get("accessToken")}`
            },
            body: JSON.stringify({
                subject: requirement.subject,
                certificationIssued: requirement.certificationIssued.format(),
                certificationExpires: requirement.certificationExpires.format(),
            }),
        })
    } catch (error) {
        const apiFailure = new ApiCallFailure()
        apiFailure.connectionSuccessful = false

        throw apiFailure
    }

    if (res!.status === 201) {
        const responseObject = await res!.json()

        const responseRequirement = new AssetReadinessRequirement()
        responseRequirement.parseObject(responseObject)

        return responseRequirement
    }

    const callFailure = new ApiCallFailure()
    callFailure.connectionSuccessful = true
    callFailure.responseCode = res!.status
    callFailure.errorType = "REQUEST_REJECTED"

    throw callFailure
}